/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type DepositListItemDtoStatus = (typeof DepositListItemDtoStatus)[keyof typeof DepositListItemDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DepositListItemDtoStatus = {
  AWAITING_PAYMENT: 'AWAITING_PAYMENT',
  REQUIRES_ACTION: 'REQUIRES_ACTION',
  PROCESSING: 'PROCESSING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const;
